import Email from "@mapmycustomers/shared/types/email/Email";

import isEmailDelivered from "./isEmailDelivered";

export interface EmailMetricsCounts {
  clickedCount: number;
  openedCount: number;
  total: number;
  undeliveredCount: number;
}

// Aggregate open/click counts across a set of per-recipient email logs.
// Undelivered recipients are excluded from every count, denominator included: they
// never received the email, so leaving them in caps the ratio below 100% forever.
// `clickedCount` requires a NON-empty `linksOpened` — `linksOpened` is always an
// array, so a truthy check would count every recipient as a click.
const getEmailMetricsCounts = (emails: Email[]): EmailMetricsCounts => {
  const delivered = emails.filter(isEmailDelivered);
  return {
    clickedCount: delivered.filter((email) => (email.linksOpened?.length ?? 0) > 0).length,
    openedCount: delivered.filter((email) => email.opened).length,
    total: delivered.length,
    undeliveredCount: emails.length - delivered.length,
  };
};

export default getEmailMetricsCounts;
